export default "__VITE_ASSET__Bvy9GAGA__"